// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__2CM7Z","error":"styles_error__cnnyk"};